import FounderPage from './FounderPage'

export default function HomePage() {
  return <FounderPage />
}
